import type { UniclientComponent } from '..';
import type { FormattedText, GridResponsiveColumns } from '../utils';
import type { UniclientBaseComponentProps, UniclientWizardComponentBase } from './types';

interface Item<TComponentAttributes extends string = string> {
  readonly value: string;
  readonly title: string;
  readonly content:
    | FormattedText
    | UniclientComponent<TComponentAttributes>
    | UniclientComponent<TComponentAttributes>[];
}

export interface AccordionProps extends UniclientBaseComponentProps {
  readonly items: Item[];
  readonly accordionType?: 'multiple' | 'single';
  readonly columns?: GridResponsiveColumns;
  readonly wrapWithCard?: boolean;
  readonly initiallyOpenedItems?: string[];
  readonly collapsible?: boolean;
}

export interface CollapsibleProps extends Omit<Item, 'value'>, UniclientBaseComponentProps {
  readonly columns?: GridResponsiveColumns;
  readonly wrapWithCard?: boolean;
  readonly initiallyOpen?: boolean;
}

export type WizardAccordionProps = AccordionProps & UniclientWizardComponentBase<'accordion'>;

export function accordion(props: Omit<AccordionProps, 'collapsible'>): WizardAccordionProps {
  return { ...props, type: 'accordion' };
}

export function collapsible(props: CollapsibleProps): WizardAccordionProps {
  return {
    ...props,
    type: 'accordion',
    items: [{ value: props.title, title: props.title, content: props.content }],
    accordionType: 'single',
    collapsible: true,
    initiallyOpenedItems: props.initiallyOpen ? [props.title] : undefined,
  };
}
